// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getInactiveInterval = createAsyncThunk('getAllInactiveIntervalSlice/getInactiveInterval', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/ScreenTracker/inactive-interval?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getUserOption = createAsyncThunk('getAllInactiveIntervalSlice/getUserOption', async () => {
    try {
        let response = await axios.get('/User?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const inactiveIntervalSlice = createSlice({
    name: 'getAllInactiveIntervalSlice',

    initialState: {
        inactiveInterval: [],
        userOption: []
    },
    reducers: {
        removeInactiveInterval: (state) => {
            state.inactiveInterval = [];
        },
        removeUserOption: (state) => {
            state.userOption = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInactiveInterval.fulfilled, (state, action) => {
            state.inactiveInterval = action?.payload;
            return;
        });
        builder.addCase(getUserOption.fulfilled, (state, action) => {
            state.userOption = action?.payload;
            return;
        });
    }
});

export const { removeInactiveInterval, removeUserOption } = inactiveIntervalSlice.actions;
export default inactiveIntervalSlice.reducer;
